export const activationDateByCountry = {
  CA: {
    en: 'November 28th 2025',
    fr: '28 novembre 2025',
    de: '28. November 2025',
  },
  US: {
    en: 'November 28th 2025',
    fr: '28 novembre 2025',
    de: '28. November 2025',
  },
  GB: {
    en: 'December 5th 2025',
    fr: '5 décembre 2025',
    de: '5. Dezember 2025',
  },
  FR: {
    en: 'December 5th 2025',
    fr: '5 décembre 2025',
    de: '5. Dezember 2025',
  },
  CH: {
    en: 'November 28th 2025',
    fr: '28 novembre 2025',
    de: '28. November 2025',
  },
  DE: {
    en: 'November 28th 2025',
    fr: '28 novembre 2025',
    de: '28. November 2025',
  },
};

export const optOutDatesByCountry = {
  CA: {
    en: 'November 25th 2025',
    fr: '25 novembre 2025',
    de: '25. November 2025',
  },
  US: {
    en: 'November 25th 2025',
    fr: '25 novembre 2025',
    de: '25. November 2025',
  },
  GB: {
    en: 'December 3rd, 2025',
    fr: '3 décembre 2025',
    de: '3. Dezember 2025',
  },
  FR: {
    en: 'December 3rd, 2025',
    fr: '3 décembre 2025',
    de: '3. Dezember 2025',
  },
  CH: {
    en: 'November 26th 2025',
    fr: '26 novembre 2025',
    de: '26. November 2025',
  },
  DE: {
    en: 'November 26th 2025',
    fr: '26 novembre 2025',
    de: '26. November 2025',
  },
};

export const feeRangesByCountry = {
  CA: {
    lowestFee: '$0.10',
    highestFee: '$0.50',
  },
  US: {
    lowestFee: '$0.10',
    highestFee: '$0.50',
  },
  GB: {
    lowestFee: '£0.10',
    highestFee: '£0.25',
  },
  FR: {
    lowestFee: '0,15 €',
    highestFee: '0,25 €',
  },
  CH: {
    lowestFee: 'CHF 0.20 TTC',
    highestFee: 'CHF 0.20 TTC',
  },
  DE: {
    lowestFee: '0,15 €',
    highestFee: '0,15 €',
  },
};

export const feeGuideLinksByCountry = {
  CA: 'https://www.paybyphone.com/sms-fees',
  US: 'https://www.paybyphone.com/sms-fees',
  GB: 'https://www.paybyphone.co.uk/fees',
  FR: 'https://www.paybyphone.fr/options-et-frais',
  CH: 'https://de.paybyphone.ch/options-sms-frais-de-service',
  DE: 'https://www.paybyphone.de/gebuhren',
};

export const optOutForm = {
  CA: 'https://pbpbusiness.zendesk.com/hc/en-gb/requests/new',
  US: 'https://pbpbusiness.zendesk.com/hc/en-gb/requests/new',
  GB: 'https://pbpbusiness.zendesk.com/hc/en-gb/requests/new',
  FR: 'https://pbpbusiness.zendesk.com/hc/fr-fr/requests/new',
  CH: 'https://pbpbusiness.zendesk.com/hc/fr-fr/requests/new',
  DE: 'https://pbpbusiness.zendesk.com/hc/de-de/requests/new',
};
